// export const base_url = 'https://api.radioplayer.fr/v2'; // prod
export const base_url = 'https://betaapi.radioplayer.fr/v2'; // dev
// export const base_url = 'https://localhost/v2'; // dev
export const site_url = 'https://www.radioplayer.fr';
export const username = 'siteweb';
export const password = '6Mh8Pc2nK';
